import { EntitlementsResponse } from '@customTypes/ItemTypes';
import { ALL_API_ENHANCEMENT } from '@helpers/constants';
import { useAppDispatch, useAppSelector } from '@redux/reduxHooks';
import { useGetEntitlementsAgainstDunsMutation, useLazyGetAssignedEntitlementsQuery } from '@redux/services/api';
import { setEntitlements, setIsLoading } from '@redux/slices/appSlice';
import { useEffect, useRef } from 'react';

const useEntitlementsForADuns = (activeDuns: string) => {
    const dispatch = useAppDispatch();
    const isPendingOwlEntitlementsAvailable = useAppSelector((state) => state.app.entitlements.isPendingOwlEntitlementsAvailable);
    const isInitialMount = useRef(true);

    // Using the mutation hook for adding a post
    const [getEntitlements, { isLoading: getEntitlementsByDunsLoading, error }] = useGetEntitlementsAgainstDunsMutation();
    const [triggerGetAssignedEntitlements, { isFetching: getAssignedLoading }] = useLazyGetAssignedEntitlementsQuery();

    const apiEnhancementCheck = async () => {
        if (ALL_API_ENHANCEMENT) {
            try {
                const response = await (activeDuns ? getEntitlements(activeDuns).unwrap() : triggerGetAssignedEntitlements().unwrap());
                if (response) {
                    const activeEntitlements: EntitlementsResponse = {
                        companyInfo: response?.companyInfo || [],
                        vboEntitlements: response?.vboEntitlements || [],
                        vboAssociatedDuns: response?.vboAssociatedDuns || [],
                        credibilityEntitlements: response?.credibilityEntitlements || [],
                        isPendingOwlEntitlementsAvailable: response?.isPendingOwlEntitlementsAvailable || false
                    };
                    dispatch(setEntitlements(activeEntitlements));
                }
            }
            catch (e) {
                console.error('Error fetching getEntitlementsAgainstDuns', e);
            }
        }
    };

    useEffect(() => {
        dispatch(setIsLoading(getEntitlementsByDunsLoading || getAssignedLoading));
    }, [getEntitlementsByDunsLoading, getAssignedLoading]);

    useEffect(() => {
        if (activeDuns) {
            apiEnhancementCheck();
        }
        else if (isPendingOwlEntitlementsAvailable) {
            if (isInitialMount.current) {
                isInitialMount.current = false;
                return;
            }
            apiEnhancementCheck();
        }
    }, [activeDuns]);

    return { error }; // Return the error from the mutation
};

export default useEntitlementsForADuns;
